export default __webpack_public_path__ + "static/media/martina-blasi-1.b88d0775.webp";